import { Box, Button, styled } from "@mui/material"
import { colors } from "../../../../styles/commonStyles"

export const AddNewUserButtonWrapper: any = styled(Button)({
  height: "40px",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
  borderRadius: "4px",
  cursor: "pointer",

  backgroundColor: colors.primaryOrange,
  "&:hover": {
    backgroundColor: colors.primaryOrange,
  },
  "&:disabled": {
    color: "#FFFFFF",
    backgroundColor: "#707070",
  },
})
